// Section Animation
const scrollVars = {
  duration: 0.6,
  ease: 'sine.in',
  stagger: 0.06,
};

function distributeByPosition(vars) {
  let distances;
  const ease = vars.ease && gsap.parseEase(vars.ease),
    from = vars.from || 0,
    base = vars.base || 0,
    axis = vars.axis,
    ratio = {center: 0.5, end: 1, edges: 0.5}[from] || 0;

  return function(i, target, a) {
    let l = a.length,
      originX, originY, x, y, d, j, minX, maxX, minY, maxY, positions;

    if (!distances) {
      distances = [];
      minX = minY = Infinity;
      maxX = maxY = -minX;
      positions = [];

      for (j = 0; j < l; j++) {
        d = a[j].getBoundingClientRect();
        x = (d.left + d.right) / 2; // based on the center of each element
        y = (d.top + d.bottom) / 2;

        if (x < minX) { minX = x }
        if (x > maxX) { maxX = x }
        if (y < minY) { minY = y }
        if (y > maxY) { maxY = y }

        positions[j] = { x, y };
      }

      originX = isNaN(from) ? minX + (maxX - minX) * ratio : positions[from].x || 0;
      originY = isNaN(from) ? minY + (maxY - minY) * ratio : positions[from].y || 0;
      maxX = 0;
      minX = Infinity;

      for (j = 0; j < l; j++) {
        x = positions[j].x - originX;
        y = originY - positions[j].y;
        distances[j] = d = !axis ? Math.sqrt(x * x + y * y) : Math.abs((axis === "y") ? y : x);

        if (d > maxX) { maxX = d }
        if (d < minX) { minX = d }
      }

      distances.max = maxX - minX;
      distances.min = minX;
      distances.v = l = (vars.amount || (vars.each * l) || 0) * (from === "edges" ? -1 : 1);
      distances.b = (l < 0) ? base - l : base;
    }

    l = (distances[i] - distances.min) / distances.max;

    return distances.b + (ease ? ease(l) : l) * distances.v;
  };
}

function initScrollParent(parent) {
  const { duration, ease, stagger } = scrollVars;

  const staggeredFades = parent.querySelectorAll('.scroll-animate__item');
  const endFades = parent.querySelectorAll('.scroll-animate__end');
  const cards = parent.querySelectorAll('.scroll-card');
  const start = parent.classList.contains('scroll-animate--small') ? 'top 95%' : 'top 80%';

  const tl = gsap.timeline({ paused: true });

  tl.from(
    parent,
    {
      opacity: 0,
      duration,
      ease,
    },
    0
  );

  if (staggeredFades.length) {
    tl.from(
      staggeredFades,
      {
        opacity: 0,
        duration,
        ease,
        stagger: {
          each: stagger,
          from: 'start',
          ease: 'power1.out',
        }
      },
      0
    );
  }
  
  if (endFades.length) {
    tl.from(
      endFades,
      {
        opacity: 0,
        duration: duration * 1.333333333,
        ease: 'sine.inOut',
      },
      duration
    );
  }
  
  ScrollTrigger.create({
    trigger: parent,
    start,
    invalidateOnRefresh: true,
    onEnter: () => {
      if (document.readyState != 'complete') {
        tl.progress(1);
        return;
      }

      tl.play();
    },
    onLeaveBack: () => {
      if (document.readyState != 'complete') {
        tl.progress(0);
        return;
      }

      tl.reverse();
    }
  });

  if (cards.length) {
    initScrollCards(cards);
  }
}

function initScrollCards(cards) {
  const { duration, ease, stagger } = scrollVars;

  const distributed = !!document.querySelector('.collection-cta');

  const getStagger = reversed => {
    return {
      each: stagger,
      from: reversed ? 'end' : 'start'
    }
  }
  const inStagger = getStagger(false);
  const outStagger = getStagger(true);

  gsap.set(cards, { opacity: 0 });

  ScrollTrigger.batch(cards, {
    start: 'top 80%',
    invalidateOnRefresh: true,
    onEnter: elements => {
      if (document.readyState != 'complete') {
        gsap.set(elements, { opacity: 1 });
        return;
      }

      gsap.to(elements, {
        opacity: 1,
        duration,
        ease,
        stagger: distributed ? distributeByPosition(inStagger) : inStagger,
        overwrite: true,
      });
    },
    onLeaveBack: elements => {
      gsap.to(elements, {
        opacity: 0,
        duration,
        ease,
        stagger: distributed ? distributeByPosition(outStagger) : outStagger,
        overwrite: true,
      });
    }
  });
}

function animateSections() {
  const scrollAnimEls = document.querySelectorAll('.scroll-animate');
  scrollAnimEls.forEach(element => initScrollParent(element));
}

animateSections();
